import ArrowIcon from "../../public/img/mall/arrow.svg";
import Image from "next/legacy/image";
import { FC, useState } from "react";
import classNames from "classnames";

const Indicator = ({ total, current, onChange }) => {
  // console.log("Indicator", { current });

  return (
    <div className="absolute bottom-[24px] left-1/2 -translate-x-1/2 flex justify-center">
      {Array(total)
        .fill("")
        .map((_, i) => {
          return (
            <button
              key={i}
              className="btn-unstyled p-[4px] flex items-center justify-center group"
              onClick={() => {
                onChange(i);
              }}
            >
              <div
                className={classNames(
                  "h-[4px] rounded-full bg-white transition group-hover:opacity-100",
                  current === i ? "w-[16px]" : "w-[4px] opacity-20"
                )}
              ></div>
            </button>
          );
        })}
    </div>
  );
};

interface ISlidesProps {
  list: string[];
}

export const Slides: FC<ISlidesProps> = ({ list = [] }) => {
  const [current, setCurrent] = useState(0);

  console.log("current", current);

  return (
    <div className="w-[500px] h-[500px] transform-gpu flex items-center justify-center">
      <div className="w-[500px] h-[500px] overflow-hidden">
        <div
          className="flex flex-nowrap transition duration-200"
          style={{ transform: `translateX(${-500 * current}px)` }}
        >
          {list.map((item, i) => {
            return (
              <div className="flex relative min-w-[500px] h-[500px]" key={i}>
                <Image src={item} layout="fill" alt="" />
              </div>
            );
          })}
        </div>
      </div>

      {list.length > 1 && (
        <>
          <button
            className={classNames(
              "absolute left-0 top-1/2 -translate-y-1/2 flex items-center justify-center btn-unstyled w-[40px] h-[40px] rounded-full transition rotate-180 border-solid border-2 border-white group",
              current === 0 ? "opacity-40" : "hover:bg-white"
            )}
            onClick={() => {
              setCurrent(current - 1);
            }}
            disabled={current === 0}
          >
            <ArrowIcon
              className={classNames(
                "transition text-white",
                current === 0 ? "" : "group-hover:text-black"
              )}
            />
          </button>

          <button
            className={classNames(
              "absolute right-0 top-1/2 -translate-y-1/2 flex items-center justify-center btn-unstyled w-[40px] h-[40px] rounded-full transition border-solid border-2 border-white group",
              current === list.length - 1 ? "opacity-40" : "hover:bg-white"
            )}
            onClick={() => {
              setCurrent(current + 1);
            }}
            disabled={current === list.length - 1}
          >
            <ArrowIcon
              className={classNames(
                "transition text-white",
                current === list.length - 1 ? "" : "group-hover:text-black"
              )}
            />
          </button>

          <Indicator
            current={current}
            total={list.length}
            onChange={(i) => {
              setCurrent(i);
            }}
          />
        </>
      )}
    </div>
  );
};
